<template>
  <div id="destaquesCarousel" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li
        v-for="(destaque, index) in banners"
        data-target="#destaquesCarousel"
        :data-slide-to="index"
        :class="!index ? 'active' : ''"
        :key="'dstq-idx-' + destaque.id + '-' + index"
      ></li>
    </ol>
    <div class="carousel-inner" id="destaquesCarrossel">
      <div v-for="(destaque, index) in banners" :class="[{ 'active': !index }, 'carousel-item']" :key="'dstq-' + destaque.id + '-' + index">
        <div class="carousel-background" :style="retornaStyleImagemUrl(destaque)">
          <a class="btn-div" href="javascript:void(0)" @click="registraCliqueDestaque(destaque.destino_url)"></a>
        </div>
        <div class="carousel-background-mobile" :style="retornaStyleImagemMobileUrl(destaque)">
          <a class="btn-div" href="javascript:void(0)" @click="registraCliqueDestaque(destaque.destino_url)"></a>
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" data-target="#destaquesCarousel" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Anterior</span>
    </a>
    <a class="carousel-control-next" data-target="#destaquesCarousel" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Próximo</span>
    </a>
  </div>
</template>

<script>
import 'bootstrap/js/dist/carousel'
import EventoAPI from '@/api/evento-api'
import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'DestaquesCarousel',
  data () {
    return {
      destaques: []
    }
  },
  props: {
    banners: Array
  },
  methods: {
    retornaStyleImagemUrl: function (destaque) {
      return {
        backgroundImage: `url("${process.env.VUE_APP_BASE_FILES_URL}${encodeURI(destaque.imagens.url)}?v=${process.env.PACKAGE_VERSION}")`
      }
    },
    retornaStyleImagemMobileUrl: function (destaque) {
      return {
        backgroundImage: `url("${process.env.VUE_APP_BASE_FILES_URL}${destaque.imagens_mobile.url}?v=${process.env.PACKAGE_VERSION}")`
      }
    },
    obterDadosUsuario: function () {
      this.usuario = LoginUtils.getUsuario()
    },
    registraCliqueDestaque: function (url) {
      let event = 'CliqueDestaqueCarrosselHome'
      let sourceSystem = 'Plataforma B2B'
      let sourceUrl = window.location.host
      let userEmail = this.usuario.email
      let userExternalId = this.usuario.id
      let userName = this.usuario.name
      let planoUsuario = this.usuario.planoPrincipal.nomeExibicaoPrincipal
      let perfilUsuario = this.usuario.perfilUsuario.descricao
      let userUuid = LoginUtils.getUuid()

      EventoAPI.registrarClique(
        event,
        sourceSystem,
        sourceUrl,
        userEmail,
        userExternalId,
        userName,
        url,
        planoUsuario,
        perfilUsuario,
        userUuid
      ).finally(() => {
        location.href = url
      })
    }
  },
  mounted () {
    this.obterDadosUsuario()
  }
}
</script>

<style scoped>
.carousel-background, .carousel-background-mobile{
  background-position: center;
  background-size: cover;
}
</style>
